import { aeroClAdapter } from './aeroCl'
import { aeroV2Adapter } from './aeroV2'
import { kyberAdapter } from './kyber'
import { uniV2Adapter } from './uniV2'
import { uniV3Adapter } from './uniV3'
import type { Adapter } from './types'
import type { Venue } from '../types'

export type { Adapter, ExecuteArgs } from './types'
export { aeroV2Adapter, uniV2Adapter, uniV3Adapter, aeroClAdapter, kyberAdapter }

const ADAPTERS: Record<Venue, Adapter> = {
  'aero-v2': aeroV2Adapter,
  'aero-cl': aeroClAdapter,
  'aero-cl3': aeroClAdapter,
  'uni-v3': uniV3Adapter,
  'uni-v2': uniV2Adapter,
  kyber: kyberAdapter
}

/**
 * The one place a venue turns into a way to send a transaction. Every route
 * the page can rank has an entry here, so a venue added to `Venue` without an
 * adapter fails to compile rather than at the moment somebody presses Swap.
 */
export function adapterFor(venue: Venue): Adapter {
  return ADAPTERS[venue]
}
